﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function header(context) {
  const navigationButton = context.querySelector('.aimo-header__menu-button');
  const navigationWrapper = context.querySelector('.aimo-navigation');
  const mapNavigationButton = context.querySelector('.aimo-header__menu-map-button');
  const mapNavigationWrapper = context.querySelector('.aimo-map-navigation');
  const htmlElement = document.querySelector('html');
  let requestAnimation = false;

  function init() {
    navigationButton.addEventListener('click', function (event) {
      if(htmlElement.classList.contains('navigation-active') || htmlElement.classList.contains('map-navigation-active')) {
        htmlElement.classList.remove('map-navigation-active');
        htmlElement.classList.remove('navigation-active');

        navigationWrapper.style.removeProperty('max-height');
        
        if (mapNavigationWrapper)
          mapNavigationWrapper.style.removeProperty('max-height');

        window.removeEventListener('resize', initMaxHeight);
        window.removeEventListener('orientationchange', initMaxHeight);
      } else {
        htmlElement.classList.add('navigation-active');

        initMaxHeight();
        window.addEventListener('resize', initMaxHeight);
        window.addEventListener('orientationchange', initMaxHeight);
      }
    });

    if (mapNavigationButton) {
      mapNavigationButton.addEventListener('click', function (event) {
        htmlElement.classList.add('map-navigation-active');
        initMaxHeight();
      });
    }
  }

	function initMaxHeight() {
    if (!requestAnimation) {
      window.requestAnimationFrame(function() {
        navigationWrapper.style.maxHeight = `${window.innerHeight}px`;
        
        if (mapNavigationWrapper)
          mapNavigationWrapper.style.maxHeight = `${window.innerHeight}px`;

        requestAnimation = false;

		if (window.innerWidth > 1164) {
          htmlElement.classList.remove('navigation-active');
          navigationWrapper.style.removeProperty('max-height');
          
          if (mapNavigationWrapper)
            mapNavigationWrapper.style.removeProperty('max-height');
          
          window.removeEventListener('resize', initMaxHeight);
          window.removeEventListener('orientationchange', initMaxHeight);
		}
      });
    }

    requestAnimation = false;
	}

  return {
    init
  };
}

controller.add('aimo-header', header);
